import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [NgClass]
})
export class LoaderComponent {
  @Input() isFixed = false;

  constructor() {}

  onClick($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
  }
}
